import React, {useState} from 'react'
import gql from 'graphql-tag'
import {Mutation} from 'react-apollo'
import SelectPhotoAssets from 'components/shared/SelectPhotoAssets'
import Button from 'components/shared/Button'

const chooseInputAssetsMutation = gql`
  mutation ChooseInputAssets($input: ChooseInputAssetsInput!) {
    ChooseInputAssets(input: $input) {
      product {
        id
        state
        requiresUserInput
        canProvideUserInput
        ...on SlideshowProduct {
          inputAssets {
            edges {
              node {
                id
                state
                ...on PhotoAsset {
                  image(size: "monitor") {
                    url
                    thumbUrl
                    width
                    height
                    labels
                    filenameIndex
                  }
                }
                ...on UrlAsset {
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`

const ChoosePhotos = ({product, setStep}) => {
  const [selectedPhotos, setSelectedPhotos] = useState([])

  const minAssets = 7
  const maxAssets = 15

  const inputAssets = product.inputAssets.edges.map(e => e.node)
  const availableInputAssets = product.availableInputAssets.edges.map(e => e.node)
  const hasSelectedPhotos = selectedPhotos.length >= minAssets && selectedPhotos.length <= maxAssets

  const hasInputAssets = inputAssets.length > 0
  const assets = hasInputAssets ? inputAssets : availableInputAssets

  return (
    <div>
        <SelectPhotoAssets
          product={product}
          photos={assets}
          minQuantity={minAssets}
          maxQuantity={maxAssets}
          selectedPhotos={selectedPhotos}
          onSelection={setSelectedPhotos}
          readOnly={hasInputAssets}
        />
        {!hasInputAssets && (
          <Mutation
            mutation={chooseInputAssetsMutation}
          >
            {(ChooseInputAssets, {loading}) => (
              <Button
                type="action"
                loading={loading}
                disabled={!hasSelectedPhotos || loading}
                onClick={() => {
                  ChooseInputAssets({
                    variables: {
                      input: {
                        productId: product.id,
                        assets: selectedPhotos.map(p => ({assetId: p.id})),
                      }
                    }
                  }).then(() => {
                    setStep('rooms')
                  })
                }}
              >
                Velg bilder
              </Button>
            )}
          </Mutation>
        )}
    </div>
  )
}

export default ChoosePhotos
